<template>
  <div class="b">
    <Nav current="公司后台"></Nav>
    <div class="titleBox">
      <span class="txt l">系统</span>
      <el-button
        type="primary"
        size="small"
        class="edit l yellow bgBtn"
        @click="addSystem"
        >添加系统
      </el-button>
    </div>
    <div class="seatch-name">
      <span>系统名称:</span> <input type="text" v-model="name" />
      <span>创建人:</span> <input type="text" v-model="userName" />
      <span class="el-icon-search" @click="searchRole"></span>
    </div>
    <div class="el-table-box">
      <el-table
        :data="tableData"
        :empty-text="emptyText"
        :props="defaultProps"
        style="width: 100%"
        :max-height="tableHeight ? tableHeight : 0"
      >
        <el-table-column
          :prop="col.prop"
          :label="col.label"
          :min-width="col.minwidth"
          :width="col.width"
          :fixed="col.fixed"
          :type="col.type"
          show-overflow-tooltip
          v-for="(col, index) in listCol"
          :key="index"
        >
          <template v-if="col.prop == 'ismaster'" scope="scope">
            {{scope.row.ismaster ? '主': '从'}}
          </template>
          <template v-else-if="col.prop == 'mongoResourceUsage'" scope="scope">
            <span class="green-txt" @click="toPath(scope.row)">{{scope.row.mongoResourceUsage}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="280">
          <template slot-scope="scope">
            <div class="link-btn border-right l" @click="editHandle(scope.row)">
              编辑
            </div>
            <div class="link-btn l" @click="deleteHandle(scope.row)">删除</div>
            <div class="link-btn l" @click="resetKey(scope.row)">重置私钥</div>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px; text-align: center">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next,jumper"
          :total="total"
          :current-page="currentPage"
          :page-sizes="[10, 30, 50, 70, 100]"
          :page-size="pageSize"
          @size-change="changePageSize"
          @current-change="changeCurrentSize"
        >
        </el-pagination>
      </div>
    </div>
    <vxe-modal v-model="isShowDelete" title="温馨提示" width="300" height="180">
      <vxe-form title-align="right" title-width="100">
        <vxe-form-item align="center" span="24">您确定要删除吗？</vxe-form-item>
        <vxe-form-item align="center" span="24">
          <template #default>
            <vxe-button @click="isShowDelete = false">取消</vxe-button>
            <vxe-button
              style="background: #55c4b8; color: #fff"
              @click="deleHandle"
              >确认</vxe-button
            >
          </template>
        </vxe-form-item>
      </vxe-form>
    </vxe-modal>

    
    <div class="ec_tip none" ref="none">
      <div class="ec-title-out">
        温馨提示 <span id="close" @click="disappear">x</span>
      </div>
      <div class="ec-cont">{{key}}</div>
      <div class="ec-but">
        <input class="butOut" type="button" value="确定" @click="disappear"/>
      </div>
    </div>

  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import apiData from "@/config/api";
import http from "@/config/httpConfig";
import axios from "axios";
import qs from "qs";
export default {
  components: {
    Nav,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      isShowDelete: false,
      disabledList:[],
      key:'',
      deleteObj: {}, //要删除的对象
      currentPage: 1,
      pageSize: 10,
      total: 10,
      name: "",
      userName: "",
      defaultProps: {
        //  列  :  显示的值
        date: "date",
        name: "name",
        address: "address",
      },
      str: "角色设置",
      tableData: [], //列表数据
      emptyText: "",
      tableHeight: "", //表格高度
      listCol: [
        {
          prop: "name",
          label: "系统名称",
          width: "200",
          id: "id",
        },
        {
          prop: "url",
          label: "系统域名",
          minwidth: "200",
        },
        {
          prop: "defaultSystem", //入库仓库
          label: "默认",
          minwidth: "100",
        },
        {
          prop: "userName",
          label: "创建人",
          minwidth: "200",
          id: "userId",
        },
        // {
        //   prop: "ismaster",
        //   label: "主库",
        //   minwidth: "100",
        // },
        {
          prop: "mongoResourceUsage",
          label: "mongo资源占用",
          minwidth: "150",
        },
        {
          prop: "createdAt",
          label: "创建时间",
          minwidth: "200",
        },
      ],
    };
  },
  mounted() {
    this.getTableHeight();
  },
  methods: {
    changePageSize(val) {
      this.pageSize = val;
      this.getTableHeight();
    },
    changeCurrentSize(val) {
      this.currentPage = val;
      // console.log(val);
      this.getTableHeight();
    },
    getTableHeight() {
      let _this = this;
      this.$nextTick(function () {
        this.clientHeight = `${document.documentElement.clientHeight}`;
        this.tableHeight = 500 + "px";

        let params = {
          pageNum: _this.currentPage,
          pageSize: _this.pageSize,
        };
        http.get(apiData.systemListWithMongo, true, params, (res) => {
          this.tableData = res.data.data.list;
          this.total = res.data.data.totalRow;
          for (let i = 0; i < _this.tableData.length; i++) {
            if (_this.tableData[i].defaultSystem == true) {
              _this.tableData[i].defaultSystem = "是";
            } else {
              _this.tableData[i].defaultSystem = "否";
            }
          }

          console.log(this.tableData);
        });
      });
    },

    addSystem() {
      this.$router.push("/company/addSystem");
    },
    toPath(row){
      this.$router.push({ name: "MongoList", query: { id: row.id } });
    },
    //编辑
    editHandle(row) {
      this.$router.push({ name: "EditSystem", query: { id: row.id } });
    },
    //删除
    deleteHandle(row) {
      let _this = this;
      _this.isShowDelete = true;
      _this.deleteObj = row;
    },

    // 重置私钥
    resetKey(row) {
      let _this = this;
      
      axios({
        method: "put",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: apiData.updateKey,
        data: qs.stringify({ id: row.id }),
      }).then((res) => {
        if (res.data.code == 200) {
        _this.disabledList = document.getElementsByClassName("none");
      for (var i = 0; i < _this.disabledList.length; i++) {
        _this.disabledList[i].style.display = "block";
      }
         _this.key= res.data.data
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    deleHandle() {
      let _this = this;
      let id = _this.deleteObj.id;
      http.delete(apiData.systemDelete, true, { id }, (res) => {
        if (res.data.code == 200) {
          _this.isShowDelete = false;
          _this.getTableHeight();
          _this.$message.success("删除成功");
        } else {
          _this.$message.error(res.data.msg);
        }
      });
      //   console.log(_this.deleteObj);
    },
    searchRole() {
      var _this = this;
      http.get(
        apiData.systemListWithMongo,
        true,
        { name: this.name, userName: this.userName },
        (res) => {
          _this.tableData = res.data.data.list;
          _this.total = res.data.data.totalRow;
          for (let i = 0; i < _this.tableData.length; i++) {
            if (_this.tableData[i].defaultSystem == true) {
              _this.tableData[i].defaultSystem = "是";
            } else {
              _this.tableData[i].defaultSystem = "否";
            }
          }
        }
      );
    },
      disappear() {
      let _this = this;
      //蒙层消失
      for (var i = 0; i < _this.disabledList.length; i++) {
        _this.disabledList[i].style.display = "none";
      }
    },
  },
 
};
</script>
<style scoped lang="less">
.b {
  margin: 0 10px;
}
/* 弹框 */
.ec_tip {
  width: 520px;
  height: 300px;
  display: none;
  position: absolute;
  left: 35%;
  top: 300px;
  background: #f8f8f8;
  color: #fff;
  z-index: 99999;
  text-align: center;
}
.mask {
  width: 100%;
  height: 980px;
  position: absolute;
  top: 0;
  display: none;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}


  .ec-cont {
    // padding: 20px;
    white-space: pre-wrap;
    word-break:normal;
    word-wrap:break-word;

    .indent {
      float: right;
      width: 511px;
      width: -17px 10px 0 0;
    }
    .explain {
      width: 80px;
    }
    .el-button {
      margin: -6px 5px 0 17px;
    }
    .el-upload__tip {
      float: right;
    }
}
.ec-cont-text {
  display: flex;
  margin-bottom: 10px;
}
.ec-title-out {
  width: 100%;
  height: 40px;
  background-color: #75c0b6;
  text-align: center;
  line-height: 40px;
  position: relative;
  margin: 0 auto;
  span {
    width: 20px;
    height: 20px;
    display: block;
    line-height: 16px;
    border: 1px solid #fff;
    border-radius: 50%;
    float: right;
    margin: 10px 10px 0 0;
  }
  .ec-but {
    margin: 20;
  }
}
.ec-title {
  width: 650px;
  height: 40px;
  background-color: #75c0b6;
  text-align: center;
  line-height: 40px;
  position: relative;
  margin: 0 auto;
}
.ec-title span {
  width: 20px;
  height: 20px;
  display: block;
  line-height: 16px;
  border: 1px solid #fff;
  border-radius: 50%;
  float: right;
  margin: 10px 10px 0 0;
}

.ec-but {
  margin-top: 22px;
  margin-left: 112px;
  display: flex;
}
.ec-cont {
  padding: 20px 10px 0 10px;
  color: #000;
  // display: flex;
  // margin-left: 15px;
  input {
    width: 363px;
    height: 30px;
    padding: 4px 6px 4px 5px;
    border: 1px solid #ccc;
    text-align: center;

  }
}
.butOut {
  width: 200px;
  height: 40px;
  background: #75c0b6;
  color: #fff;
  border: 1px solid #75c0b6;
  border-radius: 5px;
  margin-left: 20px; 
}
.titleBox {
  margin: 20px auto;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  .txt {
    display: inline-block;
    margin-right: 10px;
  }
}
.seatch-name {
  text-align: left;
  display: flex;
  input {
    width: 120px;
    height: 30px;
    padding-left: 5px;
    margin: 0 10px;
  }
  .el-icon-search {
    font-size: 20px;
    display: block;
    padding: 5px 0 0 5px;
  }
}

</style>